import { EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import type ZRText from 'zrender/lib/graphic/Text';
import { eachLineSeriesModel } from './helper';
import { DvLineSeriesModel } from './type';
import { isValidNumericValue } from './util';

function parseLineLabelCount(model: DvLineSeriesModel) {
  const dvMaxLabelCount = model.get('dvMaxLabelCount');
  const data = model.getData();
  if (!isValidNumericValue(dvMaxLabelCount)) {
    return;
  }

  let labelCountNotNull = 0;
  data.eachItemGraphicEl(symbol => {
    const textContent = symbol?.getSymbolPath()?.getTextContent() as ZRText;
    if (textContent && textContent?.style?.text) {
      labelCountNotNull += 1;
    }
  });

  data.eachItemGraphicEl(symbol => {
    if (labelCountNotNull > dvMaxLabelCount) {
      symbol.getSymbolPath().getTextContent().hide();
    } else {
      symbol.getSymbolPath().getTextContent().show();
    }
  });
}

export function install(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('series:afterupdate', (ecModel, api) => {
    eachLineSeriesModel(ecModel, model => {
      parseLineLabelCount(model);
    });
  });
}
